import React, { ButtonHTMLAttributes } from 'react';
import Button from './index';
import MergeClassNames from '../../../utils/MergeClassNames';
import { BsPlus } from 'react-icons/bs';

interface IAddNewButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  icon?: React.ReactNode;
}

export default function AddNewButton({
  text = 'Add new',
  className,
  size = 'sm',
  disabled,
  icon,
  ...props
}: IAddNewButtonProps) {
  return (
    <Button
      size={size}
      className={MergeClassNames(
        'inline-flex items-center gap-2 border-2 border-dashed border-gray-medium bg-transparent px-2 font-semibold text-gray-muted hover:border-success hover:bg-gray-50',
        disabled &&
          'cursor-not-allowed opacity-50 hover:border-gray-medium hover:bg-transparent',
        className
      )}
      disabled={disabled}
      {...props}
    >
      {icon ? (
        icon
      ) : (
        <div className="flex items-center justify-center rounded-full bg-success">
          <BsPlus className="text-white" size={14} />
        </div>
      )}
      {text}
    </Button>
  );
}
